export default "__VITE_ASSET__$gYJwdjp__"